export const devMode = process.env.NODE_ENV === 'development';

export const serverUrl = process.env.REACT_APP_API_URL+'/';

export const serverImgUrl = process.env.REACT_APP_IMAGE_API_URL;

export const apiHealthUrl = process.env.REACT_APP_API_HEALTH+'/';

export const apiUrl = `${serverUrl}`;

